import { useState } from 'react';

export type AdminDensity = 'comfortable' | 'compact';

const LS_DENSITY = 'admin_density';
const LS_SHOW_GUID = 'admin_show_guid';

export function useAdminPrefs() {
	const [density, setDensity] = useState<AdminDensity>(
		() => (localStorage.getItem(LS_DENSITY) as AdminDensity | null) ?? 'comfortable'
	);
	const [showGuid, setShowGuid] = useState<boolean>(() => localStorage.getItem(LS_SHOW_GUID) === 'true');

	const toggleDensity = () => {
		const next: AdminDensity = density === 'comfortable' ? 'compact' : 'comfortable';
		setDensity(next);
		localStorage.setItem(LS_DENSITY, next);
	};

	const toggleShowGuid = () => {
		const next = !showGuid;
		setShowGuid(next);
		localStorage.setItem(LS_SHOW_GUID, String(next));
	};

	return { density, showGuid, toggleDensity, toggleShowGuid };
}
